import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push;                               // 1.解决router路由对象转跳自身页面报错
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};


                                                                              // 2.导入页面组件
import helpCenter from '../views/helpCenter/helpCenter.vue';                  // 2.1.页面-帮助中心
import orderFind from '../views/orderFind/orderFind.vue';                     // 2.2.页面-订单查询
import giftsExchange from '../views/giftExchange/giftsExchange.vue';            // 2.3.页面兑换
import home from '../views/home/home.vue';                                    // 2.4.页面-首页
import goodsList from '../views/goodsList/goodsList.vue';                     // 2.5.页面-兑换套餐列表
import goodsAddress from '../views/goodsAddress/goodsAddress.vue';            // 2.6.页面-收货地址
import address from '../views/goodsAddress/address.vue';
import succes from '../views/goodsAddress/succes.vue'; 
import orderDetail from '../views/orderDetail/orderDetail.vue';               // 2.7.页面-订单详情
import ggDetail from '../views/ggDetail/ggDetail.vue';                        // 2.8.页面-公告详情
import goodsDetail from '../views/goodsDetail/goodsDetail.vue';               // 2.9.页面-商品详情
import trackInfo from '../views/trackInfo/trackInfo.vue';                     // 2.9.页面-物流详情
import chooseCards from '../views/chooseCards/chooseCards.vue';               // 2.10.页面-选择卡
import goodsList1 from '../views/goodsList/goodsList1.vue';                     // 3.1.页面-兑换套餐列表
import goodsAddress1 from '../views/goodsAddress/goodsAddress1.vue';            // 3.2.页面-收货地址
import address1 from '../views/goodsAddress/address1.vue';
import succes1 from '../views/goodsAddress/succes1.vue'; 
import shop from '../views/shop/shop.vue';                                      //3.3.页面-已选套餐页

                                    
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/helpCenter',
    component: helpCenter,
  },
  {
    path: '/orderFind',
    component: orderFind,
  },
  {
    path: '/giftsExchange',
    component: giftsExchange,
  },
  {
    path: '/home',
    component: home,
  },
  
  {
    path: '/goodsList',
    component: goodsList, 
  },
  {
    path: '/goodsAddress',
    component: goodsAddress,
  },
  {
    path: '/address',
    component: address,
  },
  {
    path: '/succes',
    component: succes,
  },
  {
    path: '/orderDetail',
    component: orderDetail,
  },
  {
    path: '/ggDetail',
    component: ggDetail,
  },
  {
    path: '/goodsDetail',
    component: goodsDetail,
  },
  {
    path: '/trackInfo',
    component: trackInfo,
  },
  {
    path: '/chooseCards',
    component: chooseCards,
  },
  {
    path: '/goodsList1',
    component: goodsList1, 
  },
  {
    path: '/goodsAddress1',
    component: goodsAddress1,
  },
  {
    path: '/address1',
    component: address1,
  },
  {
    path: '/succes1',
    component: succes1,
  },
  {
    path: '/car',
    component: shop
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router
